import React, { Component } from "react";
import PropTypes from "prop-types";
import { Div } from "glamorous";
import styles from "../../../styles";
import data from "../../../data";
import { baseURL } from "../../../misc/api";
import { ExperienceConsumer } from "../../../providers/ExperienceContext";

class Legal extends Component {
  state = { content: null };

  componentDidMount() {
    // hack!
    let fileName = this.props.name;

    if (this.context.isInStore && fileName === 'terms') {
      fileName = 'instore-terms';
    }

    console.log(this.context.isInStore, fileName);

    fetch(`${baseURL}/legal/${data.getLocale()}/${fileName}`)
      .then(response => response.text())
      .then(content => this.setState({ content }));
  }

  render() {
    return (
      <Div className="container container--generic">
        <Div
          css={styles.generic}
          dangerouslySetInnerHTML={{ __html: this.state.content || null }} />
      </Div>
    );
  }
}

Legal.propTypes = {
  name: PropTypes.string.isRequired
};

Legal.contextType = ExperienceConsumer;
export default Legal;



// WEBPACK FOOTER //
// ./src/components/areas/Legal/index.js